// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as m from './messages';
import { isValidNumber } from 'libphonenumber-js';
import { messageFormat } from 'common/utils';

export const required = value =>
  value ? undefined : messageFormat(m.REQUIRED);

export const len = length => value =>
  value && value.length !== length
    ? messageFormat(m.STRING_LENGTH, { length })
    : undefined;

export const maxLength = length => value =>
  value && value.length > length
    ? messageFormat(m.MAX_LENGTH, { length })
    : undefined;

export const minLength = length => value =>
  value && value.length < length
    ? messageFormat(m.MIN_LENGTH, { length })
    : undefined;

export const number = value =>
  value && isNaN(Number(value)) ? messageFormat(m.NUMBER) : undefined;

export const minValue = min => value =>
  value && value < min
    ? messageFormat(m.MIN_VALUE, { min_value: min })
    : undefined;

export const maxValue = max => value =>
  value && value > max
    ? messageFormat(m.MAX_VALUE, { max_value: max })
    : undefined;

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? messageFormat(m.INVALID_EMAIL)
    : undefined;

export const alphaNumeric = value =>
  value && /[^a-zA-Z0-9 ]/i.test(value)
    ? messageFormat(m.ALPHANUMERIC)
    : undefined;

export const basicPhoneNumber = value =>
  // Regex is from https://stackoverflow.com/a/29767609/556510
  value &&
  !/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(value)
    ? messageFormat(global.translations.messages[m.INVALID_PHONE])
    : undefined;

export const countryPhoneNumber = (value, optionalCountry) =>
  value && !isValidNumber(value, optionalCountry)
    ? messageFormat(global.translations.messages[m.INVALID_PHONE])
    : undefined;

export const oneOf = validValues => value =>
  validValues.indexOf(value) === -1 ? messageFormat(m.NOT_IN_LIST) : undefined;

export const usZipcodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
export const zipcode = value =>
  value && !usZipcodeRegex.test(value)
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;

export const state = states => oneOf(states.map(s => s.value));

export const ukZipcodeRegex = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) {0,1}[0-9][A-Za-z]{2})/;
export const ukZipCode = value =>
  value && !ukZipcodeRegex.test(value) ? 'Invalid postal code' : undefined;

// Israel zip codes are either 5 or 7 digits
export const ilZipCode = value =>
  value && value.length !== 5 && value.length !== 7
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;

// Canadian postal codes are 6 characters, alternating letter then number, with an optional space in the middle.
export const caZipCodeRegex = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
export const caZipCode = value => {
  return !caZipCodeRegex.test(value)
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;
};

// Swizz postal codes are 4 digits. First is district, second is area, third is route, fourth is post office number.
// source: https://www.grcdi.nl/gsb/switzerland.html
export const chZipCodeRegex = /^[1-9]\d{3}$/;
export const chZipCode = value =>
  value && !chZipCodeRegex.test(value)
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;

// German postal codes of the form: 'DDDDD'. All digits arse used. First digit is the distribution zone,
// second a distribution region. Other digits indicate the distribution district and postal town.
// source: https://www.grcdi.nl/gsb/germany.html
export const deZipCodeRegex = /^((0)[1-4|6-9]\d{3}|(4)[0-2|4-9]\d{3}|(6)[0-1|3-9]\d{3}|[1-3|5|7-9]\d{4})$/;
export const deZipCode = value =>
  value && !deZipCodeRegex.test(value)
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;

// Spain postal codes of the form: 'DDDDD'. All digits are used. First two
// digits indicates the province. The third a place within the province.
// source: https://www.grcdi.nl/gsb/spain.html
export const esZipCodeRegex = /^((0)[1-9]\d{3,3}|[1-4]\d{4,4}|(5)[0-2]\d{3,3})$/;
export const esZipCode = value =>
  value && !esZipCodeRegex.test(value)
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;

// French postal codes of the form: 'DDDDD'. All digits are used. First two digits indicate the department,
// and range from 01 to 98, or 00 for army. Metropolitan France has postal codes commencing 00-95 and 99.
// source: https://www.grcdi.nl/gsb/france.htm
export const frZipCodeRegex = /^([0-8][0-9]\d{3}|[9][0-6]\d{3}|(99)\d{3})$/;
export const frZipCode = value => {
  return value && !frZipCodeRegex.test(value)
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;
};

// Russia Postal codes consist of a block of 6 digits. The first three digits indicate the region or large town,
// the last three the post office. Postal codes can begin with a 1-4 or 6.
// No codes currently begin with 22, 25-29, 31-33, 37, 47-49, 5 or 7-9.
// source: https://www.grcdi.nl/gsb/russia.html
export const ruZipCodeRegex = /^([1|6]\d{5}|[2][0|1|3|4]\d{4}|[3][0|4|5|6|8|9]\d{4}|[4][0-6]\d{4})$/;
export const ruZipCode = value =>
  value && !ruZipCodeRegex.test(value)
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;

// Italy postal codes consist of a block of 5 digits, and are highly correlated with administrative districts.
// No codes currently begin with 49, 68, 69, 76, 77, 78, 79, 99
// source: https://www.grcdi.nl/gsb/italy.html
export const itZipCodeRegex = /^(?!49|68|69|76|77|78|79|99)[0-9]{5}$/;
export const itZipCode = value =>
  value && !itZipCodeRegex.test(value)
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;

// South Korea postal codes consist of a block of 5 or 6 digits
export const krZipCodeRegex = /^\d{3}(?:\d{2}|-\d{3})$/;
export const krZipCode = value =>
  value && !krZipCodeRegex.test(value)
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;

// Poland postal codes have 5 digits.
// source: https://www.grcdi.nl/gsb/poland.html
export const plZipCodeRegex = /^(\d{2,2}(-)\d{3,3})$/;
export const plZipCode = value =>
  value && !plZipCodeRegex.test(value)
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;

// Ireland postal codes consist of 7 digits of letters and numbers, not including B, G, I, J, L, M, O, Q or S
// regex source: https://github.com/dgilperez/validates_zipcode/blob/f0415c1b3864a9888b3310e39c98f625aa5f1a0c/lib/validates_zipcode/cldr_regex_collection.rb#L16
export const ieZipCodeRegex = /^([AC-FHKNPRTV-Y]\d{2}|D6W)\s?[0-9AC-FHKNPRTV-Y]{4}$/;
export const ieZipCode = value =>
  value && !ieZipCodeRegex.test(value)
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;

// Netherlands postal codes consist of four digits followed by two uppercase letters
// with an empty space inbetween.
// First digit cannot be 0 and the two letters cannot be SS, SA, or SD.
// source: https://www.grcdi.nl/gsb/netherlands.html#H7850D12EA45D65E283BB536CBC7222059B48448A036NetherlandsA20A2DA20A5BA5BPostalA20codeA20formatA5DA5D00C00F012015018021028031034
export const nlZipCodeRegex = /^([1-9]\d{3,3}( )([A-R|T-Z][A-Z]|[S][B|C|E-R|T-Z]))$/;
export const nlZipCode = value =>
  value && !nlZipCodeRegex.test(value)
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;

// Belgium postal codes consist of four digits
// The first digit cannot be 0 and the first two digits cannot be 57, 58, 59
export const beZipCodeRegex = /^(([1-4|6-9]\d{3})|(5[0-6]\d{2}))$/;
export const beZipCode = value =>
  value && !beZipCodeRegex.test(value)
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;

// New Zealand postal codes consist of four digits
// source: https://www.grcdi.nl/gsb/new%20zealand.html#H7E4D641286DDC303E468F66EFE371BDA8081FC9103CA2AA2ANewA20ZealandA20A2DA20A5BA5BPostalA20codesA5DA5DA2AA2A00100400A01401701A01D02002903103403703A
export const nzZipCodeRegex = /^\d{4,4}$/;
export const nzZipCode = value =>
  value && !nzZipCodeRegex.test(value)
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;

// Czech Republic postal codes consist of 5 digits
// with a space between 3rd and 4th digit.
// The first digit can start with any number between 1-7 and other digits can have any digits from 0 to 9.
// source: https://www.grcdi.nl/gsb/czechia%20_%20czech%20republic.html
export const czZipCodeRegex = /^[1-7]\d{2,2}[ ]\d{2,2}$/;
export const czZipCode = value =>
  value && !czZipCodeRegex.test(value)
    ? messageFormat(m.INVALID_ZIPCODE)
    : undefined;

// If the country requires a zipcode, or if one is passed in, validate the zipcode with appropriate country
// Otherwise, pass undefined to mark it validated
const zipWrapper = country_validator => {
  return value => {
    if (gon.zipcode_required || !!value) {
      return country_validator(value);
    }
    return undefined;
  };
};

export const getZipValidator = (country = 'US') => {
  const countryMap = {
    BE: beZipCode,
    CA: caZipCode,
    CH: chZipCode,
    CZ: czZipCode,
    DE: deZipCode,
    ES: esZipCode,
    FR: frZipCode,
    GB: ukZipCode,
    IE: ieZipCode,
    IL: ilZipCode,
    IT: itZipCode,
    KR: krZipCode,
    NL: nlZipCode,
    NZ: nzZipCode,
    PL: plZipCode,
    RU: ruZipCode,
    US: zipcode,
  };
  return zipWrapper(countryMap[country]);
};

export const deAddress1Regex = /^(?![0-9]).*$/;
export const deAddress1 = value =>
  value && !deAddress1Regex.test(value)
    ? messageFormat(m.INVALID_DE_ADDRESS1)
    : undefined;

export const getAddress1Validator = country => {
  const countryMap = { DE: deAddress1 };
  return countryMap[country] || (() => undefined);
};

// Cybersource gateway has a max length of 35 for any address field
const maxLength35 = maxLength(35);
export const cybersource = value => maxLength35(value);

const minLength6 = minLength(6);
export const password = value => minLength6(value);

export const passwordsMatch = values =>
  values.password !== values.password_confirmation
    ? messageFormat(m.PASSWORDS_MATCH)
    : undefined;

export const notOnlyWhitespace = field => {
  const regex = /\S/;

  return !regex.test(field)
    ? messageFormat(global.translations.messages[m.NOT_ONLY_WHITESPACE])
    : undefined;
};

// PASSPORT NUMBER

// Russian domestic passport numbers are 10 digits
// https://sayari.com/decoding-russian-passport-numbers/
export const ruPassportNumberRegex = /^([0-9]{10})$/;
export const ruPassportNumber = value =>
  value && !ruPassportNumberRegex.test(value)
    ? messageFormat(m.INVALID_PASSPORT_NUMBER)
    : undefined;

export const getPassportNumberValidator = country => {
  const countryMap = {
    RU: ruPassportNumber,
  };

  return countryMap[country] || (() => undefined);
};

// Italy Codice Fiscale are user tax codes that are 16 characters
// regex is same as used in user_tax_code_validator.rb
export const itTaxCodeRegex = /^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i;
export const itTaxCode = value =>
  value && !itTaxCodeRegex.test(value)
    ? messageFormat(m.INVALID_USER_TAX_CODE)
    : undefined;

export const getUserTaxCodeValidator = country => {
  const countryMap = {
    IT: itTaxCode,
  };

  return countryMap[country] || (() => undefined);
};
